import React, {Component} from "react";
import styled from "styled-components";
import { Title, Header, Body, ButtonTitle, ActionButtonTitle } from "../components/Fonts"
import {
  PageContainer, ReversedSectionContainer,
  SectionContainer,
  SectionGroup,
  SectionItem, SectionSpacer
} from "../components/conatiner/Container";
import NavigationHeader from "../components/navigationHeader/NavigationHeader";

import cameraSpeaker from "../images/illustrations/cameraSpeaker.png";
import { Button, ActionButton, ButtonIcon } from "../components/button/ActionButton";
import appleIcon from "../images/icons/apple.png";
import playIcon from "../images/icons/play.png";
import heroIllustration from "../images/illustrations/hero.png";
import linkIcon from "../images/icons/link.png";
import snapIllustration from "../../images/illustrations/snap.png";
import fastIlustration from "../../images/illustrations/fast.png";
import callIllustration from "../../images/illustrations/call.png";
import {DistinctSpacer} from "../components/Spacer";
import {PortraitIllustration, SquareIllustration} from "../components/conatiner/Illustration";
import Footer from "../components/footer/Footer";
import { Link } from 'react-router-dom';
import TransparentNavigationHeader from "../components/navigationHeader/TransparentNavigationHeader";
import TransparentFooter from "../components/footer/TransparentFooter";

const Logo = styled.div`
  width: 520px;
  height: calc(100vh - 220px);
  background: url(${cameraSpeaker}) no-repeat center;
  background-size: 520px;
  margin: 0 auto;

  @media only screen and (max-width: 768px) {
    max-width: 520px;
    width: 100%;
    height: calc(100vh - 340px);
    background-size: 100%;
    margin: 40px auto;
  }
`;

const ColoredPageContainer = styled(PageContainer)`
  max-width: 100%;
  background-image: linear-gradient(to bottom right, #FE992E, #FE6A33, #FE3729);
`;

class LandingPage extends Component {
  //  As the landing pages is static, there is no need to re-render.
  shouldComponentUpdate() {
    return false;
  }

  onAppStore = () => {
    // @ts-ignore
    window.open("https://apps.apple.com/us/app/zebra-share-talking-photos/id1548469840", '_blank').focus();
  }

  render() {
    return (
      <ColoredPageContainer>
        <TransparentNavigationHeader isPreview={false}/>
        <Logo/>
        <TransparentFooter/>
      </ColoredPageContainer>
    );
  }
}

export default LandingPage;